import { VehicleStateModel } from '../models/vehicle-state.model';
import { VehicleDataModel } from './../models/vehicle-data.model';
import { Injectable } from '@angular/core';
import { VehicleQuestionModel } from '../models/vehicle-question.model';
import { VehicleQuestionCode } from '../consts/vehicle-question-code.enum';
import { isNullOrUndefined } from 'util';
import { VehicleRegistrationData } from '../models/registration-offer-data/vehicle-registration-data.model';

@Injectable({
  providedIn: 'root'
})
export class VehicleQuestionsService {

  constructor() { }

  updateQuestion(parent: QuestionsParent, fieldKey: string, value: any) {
    const questionIndex = this.findIndexToUpdate(parent, VehicleQuestionCode[fieldKey]);
    if (!isNullOrUndefined(questionIndex)) { // question index was found
      parent.questions[questionIndex].questionAnswer = value;
    } else { // question index wasn't found - push new question
      const question: VehicleQuestionModel = {
        questionCode: VehicleQuestionCode[fieldKey],
        questionAnswer: value
      };
      parent.questions.push(question);
    }
  }

  private findIndexToUpdate(parent: QuestionsParent, questionCode: string): number {
    for (let i = 0; i < parent.questions.length; i++) {
      if (parent.questions[i].questionCode === questionCode) {
        return i;
      }
    }
    return null;
  }
}

export type QuestionsParent = VehicleDataModel | VehicleStateModel | VehicleRegistrationData;
